import { useAppDispatch, useAppSelector } from 'app/hooks';
import { setActiveConfig } from 'features/configurations';
import { setActiveTab } from 'features/ui';
import useTabLocks from 'hooks/use-tab-locks';
import { useEffect } from 'react';
import {
  selectActiveDuctedDesignIndex,
  selectIsDuctedDesignPending
} from 'utils/ducted-design';

// The tabs in the active System Design bypass mode's locks are hidden
// (System Design) or locked (Add-Ons) at the header gate, but activeTab is
// not persisted and a session can be SITTING on one when a lock arms
// mid-session (the preference flips, or the last mini-split room is
// removed on the hybrid path) or when a restored activeTab lands on it.
// The same goes for the Choose Systems lock while a required ducted System
// Design is incomplete; that escape also brings the pending design's tab
// forward so the user lands on the configuration that needs finishing.
export default function TabLockWatcher() {
  const dispatch = useAppDispatch();
  const activeTab = useAppSelector((state) => state.ui.activeTab);
  const tabLocks = useTabLocks();
  const ductedDesignPending = useAppSelector(selectIsDuctedDesignPending);
  const activeConfig = useAppSelector(
    (state) => state.configurations.activeConfig
  );
  const pendingDesignIndex = useAppSelector(selectActiveDuctedDesignIndex);

  useEffect(() => {
    const lock = tabLocks[activeTab];
    if (!lock) return;
    dispatch(setActiveTab(lock.escapeTo));
    if (
      ductedDesignPending &&
      pendingDesignIndex >= 0 &&
      pendingDesignIndex !== activeConfig
    ) {
      dispatch(setActiveConfig(pendingDesignIndex));
    }
  }, [
    activeTab,
    tabLocks,
    ductedDesignPending,
    activeConfig,
    pendingDesignIndex,
    dispatch
  ]);

  return null;
}
